module.exports = {
  ENDED: 'ended',
  LIVE: 'live',
  LIVE_IN: 'live_in',
  SOLD_OUT: 'sold_out',
};
